import * as userRequest from "@/utils/userRequest";

export default async function sendOTPValidateService(
    token: string,
    type: string,
    service?: string,
    onSuccess?: (data?: any) => any,
    handleError?: (err?: any) => any
) {
    try {
        const res = await userRequest.post(
            "auth/send-otp-validate",
            {
                type,
                service,
            },
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );
        if (res) {
            onSuccess && onSuccess(res);
            return res;
        }
    } catch (err) {
        console.error("🚀 ~ sendOTPClaimService ~ err:", err);
        handleError && handleError(err);
        throw err;
    }
}
